import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Switch, message } from "antd";
import cn from "classnames";

import "./index.less";

/**
 * 通知设置
 *
 */
const NotificationSettings = ({ userInfo, updateUserInfo }) => {
  const { t } = useTranslation();
  const handleChange = (name, value) => {
    updateUserInfo({ [name]: value })
  };
  const handleCheck = (name, value) => {
  };

  const list = useMemo(() => { 
    return [{ title: t("Notification.whatsapp"), name: 'accept_whatsapp', isOpen: !!userInfo.accept_whatsapp }]
  }, [userInfo]);

  return (
    <div className="dc-notification-settings">
      {/* <div className="dc-notification-settings-notice">
        {t(
          "Notification.which_channels_would_you_like_to_receive_notifications_from"
        )}
      </div> */}
      {list.map((item) => (
        <NotificationSettingsCard
          key={item.name}
          {...item}
          handleChange={handleChange}
          handleCheck={handleCheck}
        />
      ))}
    </div>
  );
};

const NotificationSettingsCard = ({
  title,
  name,
  isOpen,
  handleChange,
  handleCheck,
}) => {
  return (
    <div className="dc-notification-settings--card">
      <div className="dc-notification-settings--card-head">
        <div className="dc-notification-settings--card-head-title">{title}</div>
        <div className="dc-notification-settings--card-head-tools">
          <Switch
            checked={isOpen}
            onChange={(val) => handleChange(name, val)}
          ></Switch>
        </div>
      </div>
      <div
        style={{ height: 0 }}
        className={cn("dc-notification-settings--card-body")}
      >
        <div className="dc-notification-settings--card-item">
          <div className={cn("dc-notification-settings--card-checkbox")}></div>
          <div className="dc-notification-settings--card-label">
            Transactions (notifications related to bookings, deals, or
            vouchers.)
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
